import React, { Component } from 'react';

import { Container } from 'reactstrap';

import Background from '../../../../components/background';
import Column from '../../../../components/column';
import Icon from '../../../../components/icon';
import Spacer from '../../../../components/spacer';
import Text from '../../../../components/text';

import './styles.scss';

class UnauthenticatedFooter extends Component {
  render = () => {
    return (
      <Container fluid className="footer">
        <Background lightGrey className={'row'}>
          <Column
            xs={12}
            sm={{ size: 8, offset: 2 }}
            spacing={{ vertical: true, extraLarge: true }}
          >
            <Text standardWeight>
              <a
                href="https://www.facebook.com/Accurx/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  medium
                  type={'svg'}
                  icon="facebook"
                  spacing={{ right: true }}
                />
              </a>

              <a
                href="https://twitter.com/Accurx"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon medium type={'svg'} icon="twitter" />
              </a>

              <Text darkGrey small block spacing={{ vertical: true }}>
                <Spacer right={true}>
                  <a className="link" href={`https://www.accurx.com/terms-and-conditions`}>
                    {' '}
                    Terms and Conditions{' '}
                  </a>
                </Spacer>
                <Spacer right={true}>
                  <a
                    className="link"
                    href={`https://www.accurx.com/privacy-policy`}
                  >
                    {' '}
                    Privacy Policy
                  </a>
                </Spacer>
                <a className="link" href={`https://www.accurx.com/cookie-policy`}>
                  {' '}
                  Cookies Policy
                </a>
              </Text>

              <Text
                darkGreyLighter
                small
                block
                spacing={{ bottom: true, large: true }}
              >
                <a href="mailto:support@accurx.com" itemProp="email">
                  support@accurx.com
                </a>
              </Text>

              <Text lightGrey small block spacing={{ bottom: true }}>
                © Accurx Limited, c/o 7 Curtain Road, London, EC2A 3LT
              </Text>

              <Text lightGrey tiny block>
              Accurx Limited is a company registered in the United Kingdom with company number 10184077
              </Text>
            </Text>
          </Column>
        </Background>
      </Container>
    );
  };
}

export default UnauthenticatedFooter;
